var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplyPortalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8326 1.08921C31.8529 0.970264 32.025 0.970264 32.0453 1.08921C32.202 1.98757 32.905 2.69059 33.8034 2.84725C33.9223 2.86756 33.9223 3.03969 33.8034 3.05999C32.905 3.21665 32.202 3.91967 32.0453 4.81803C32.025 4.93698 31.8529 4.93698 31.8326 4.81803C31.6759 3.91967 30.9729 3.21665 30.0746 3.05999C29.9556 3.03968 29.9556 2.86755 30.0746 2.84725C30.9729 2.69059 31.6759 1.98757 31.8326 1.08921ZM36.7674 3.40428C36.7307 3.1954 36.4309 3.1954 36.3942 3.40428C36.1205 4.97568 34.8895 6.20662 33.3181 6.48038C33.1092 6.51712 33.1092 6.81689 33.3181 6.85365C34.8895 7.12733 36.1204 8.35834 36.3942 9.92975C36.4309 10.1386 36.7307 10.1386 36.7674 9.92975C37.0411 8.35834 38.2721 7.12741 39.8435 6.85365C40.0524 6.81691 40.0524 6.51714 39.8435 6.48038C38.2721 6.2067 37.0412 4.97568 36.7674 3.40428Z",
    fill: "#5F6388",
    stroke: "#673898",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09939 12.6446H27.0137C39.1462 12.6446 39.1462 30.9852 27.0137 30.9852H9.09939C-3.03313 30.9852 -3.03313 12.6446 9.09939 12.6446ZM26.9181 16.6725C29.7613 16.6725 32.036 18.9473 32.036 21.7904C32.036 24.6335 29.7612 26.9563 26.9181 26.9563C24.075 26.9563 21.7522 24.6338 21.7522 21.7904C21.7522 18.9471 24.0747 16.6725 26.9181 16.6725Z",
    fill: "#673898"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4921,
    cy: 22.0137,
    r: 5.09459,
    fill: "#65FFCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyPortalIcon);
export default __webpack_public_path__ + "static/media/SupplyPortalIcon.e63e7089bc627aa187be470a52ef7983.svg";
export { ForwardRef as ReactComponent };